export default "__VITE_ASSET__CMYpoHAV__"